import React from 'react'

export default function SuccessModal() {
    return (
        <div className="success-modal">
            <h3 className="m-0"><i className="fa fa-check-circle mr-3" /> Color copied to the clipboard!</h3>
        </div>
    )
}
